var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default panel-dashboard"},[(_vm.loading)?_c('loading-spinner'):_c('div',{staticClass:"panel-body"},[_c('canvas',{attrs:{"width":"800","height":"250"}})]),_vm._v(" "),_c('AchievementsModal',{attrs:{"competition":_vm.competition,"competition-team-id":_vm.competitionTeamId,"date":_vm.date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }